import script from "./highSeas.vue?vue&type=script&setup=true&lang=js"
export * from "./highSeas.vue?vue&type=script&setup=true&lang=js"

import "./highSeas.vue?vue&type=style&index=0&id=3753ce34&scoped=true&lang=stylus"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3753ce34"]])

export default __exports__